<template>
  <page :custom-style="{ 'padding-top': pagePaddingTopValue }">
    <!-- 
      支持crm 直接进二级页面
      <div
      v-if="!browerInfo.isMiniProgram && !browerInfo.isMallApp"
      ref="downloadWrap"
      class="download-wrap"
    >
      <img class="logo" src="../../images/app/mc_logo.png" />
      <div class="info">
        <span class="title">{{ APP_CONFIG.app_name }}  App</span>
        <span class="desc">批发买菜，上{{ APP_CONFIG.app_short_name }}，就是便宜</span>
      </div>

      <div class="btn open-btn" @click="openAppSchema">打开</div>
      <div class="btn download-btn" @click="onClickDownload">下载</div>
    </div> 
    -->
    <maple-nav-bar
      v-if="!browerInfo.isMiniProgram"
      class="cms-nav-bar"
      left-arrow
      :safe-top-distance="statusBarHeight"
      :opacity-style="opacityNavBar"
      :opacity="opacity"
      :title="navBarTitle"
      :right-icon="wxShareBtnAppShow ? 'share_outlined' : ''"
      :style="{ top: downLoadHeight + 'px!important' }"
      @click-left="goBack"
      @click-right="wxShareBtnClick"
    />
    <tangram ref="tangram" />
    <feed
      v-if="renderFeedGood"
      :feed-tab-data="feedTabData"
      :cms-page-id="Number(pageId)"
    />
    <strageGood v-if="renderStrage" :feed-tab-data="strageTabData"></strageGood>
    <cart-float-window v-if="showCartFloatWindow" />
    <empty
      v-if="showEmpty"
      :desc="
        isShowLoginBar
          ? '您还未登录，请先登录'
          : '啊哦，页面是空的，去别处逛逛吧'
      "
      :show-btn="false"
    ></empty>
    <div class=""></div>
    <img
      v-if="wxShareBtnAppShow"
      src="@/images/cms/wxshare/wxshare-btn.png"
      class="wxshare-btn"
      @click="wxShareBtnClick"
    />
    <img
      v-if="wxShareMpShow"
      src="@/images/cms/wxshare/wxshare-tip.png"
      class="wxshare-tip"
    />
    <login-bar
      v-if="isShowLoginBar"
      text="登录后，可加购"
      left-icon="dingwei"
      right-icon="mc-icon-arrowright"
      right-icon-text="立即登录"
      :spm="cmsPage.loginBarClick"
    ></login-bar>
    <div v-if="isLoading" class="expand-loading">
      <div class="loading-content">
        <img src="../../images/loading/loading3.gif" class="loading-img" />
      </div>
    </div>
  </page>
</template>

<script>
import { tickets } from '@/defines/user'
// eslint-disable-next-line no-unused-vars
import { API } from '@/api'
import empty from '@/common/layout/empty_v2/index'
import Tangram from '@/common/widgets/tangram'
import feed from '@/common/widgets/feed'
import loginBar from '@/common/widgets/loginBar'
import CartFloatWindow from '@/common/widgets/cart_float_window'
import { NavBar } from '@mc/mc-jsbridge'

import { isMallApp } from '@mc/mc-base-env/src/web/platform'
import tracerVuePlugin from '@mc/tracer-vue-plugin'
import { resolveUrlParams } from '@/utils/utils'
import strageGood from '@/common/cms/modules/strageGood'
import {
  onAppShareBtnClick,
  setCmsWxShareInfo
  // setCmsHeader
} from '@/utils/cms_share'
import { mpsCombination } from '@/utils/native_interactions/mps_combination'
import { miniProgramEnv } from '@/defines/environment'
import { openApp, downLoadApp } from '@/utils/app_download'
import { cmsPage } from '@/utils/tracer/track_map/modules/cms_page'
import { THEME_COLOR, APP_CONFIG } from '@/defines/environment/config'

export default {
  name: 'PageCMS',
  components: {
    Tangram,
    CartFloatWindow,
    empty,
    feed,
    loginBar,
    strageGood
  },
  beforeRouteEnter(to, from, next) {
    const pageId = to.params.pageId
    next(vm => {
      const navBar = new NavBar(0)

      navBar.init()
      vm.pageId = pageId
      vm.fetchCMSContent(pageId)
    })
  },
  onLogin() {
    window.location.reload()
  },
  data() {
    return {
      pageId: 0,
      opacityNavBar: false,
      opacity: 0,
      navBarTitle: '',
      showEmpty: false,
      showCartFloatWindow: false,
      renderFeedGood: false,
      feedTabData: {},
      wxShareBtnAppShow: false,
      wxShareMpShow: false,
      wxShareInfo: {
        share_name: '',
        share_img: '',
        share_url: '',
        share_desc: ''
      },
      pagePaddingTopValue: '',
      browerInfo: window.matrix,
      downLoadHeight: 0,
      cmsPage,
      isLoading: false,
      cmsStayDTO: {}, // 用户挽留
      APP_CONFIG,
      strageTabData: {},
      renderStrage: false
    }
  },
  computed: {
    isShowLoginBar() {
      if (
        this.browerInfo.isMiniProgram ||
        this.browerInfo.baseParams.previewToken
      )
        return false
      return !tickets
    },
    isMallAppMp() {
      return this.browerInfo.isMiniProgram || this.browerInfo.isMallApp
    }
  },
  methods: {
    pagePaddingTop(height) {
      if (!miniProgramEnv.isMiniProgram) {
        if (this.opacityNavBar) {
          return 0 + 'px'
        }
        if (!this.browerInfo.isMallApp) {
          if (height) {
            return 44 + this.statusBarHeight + height + 'px'
          }
          return 44 + this.statusBarHeight + 'px'
        }
        return 44 + this.statusBarHeight + 'px'
      } else {
        return '0px'
      }
    },

    // 打开APP
    openAppSchema() {
      this.$track(this.$trackMap.appOpen.CMS_OPEN_CLICK)
      openApp({
        showWxBrowerPopup: true,
        openToast: () => {
          this.$toast({
            message:
              '您当前浏览器版本可能无法自动打开APP，若未正常打开，请尝试手动打开APP。',
            duration: '4000'
          })
        }
      })
    },

    // 下载APP
    onClickDownload() {
      this.$track(this.$trackMap.appDownload.CMS_DOWNLOAD_CLICK)
      downLoadApp()
    },

    async fetchCMSContent(cmsPageId) {
      this.isLoading = true
      try {
        if (cmsPageId) {
          // eslint-disable-next-line no-unused-vars
          const res = await API.cms.getById({
            pageid: Number(cmsPageId)
          })
          this.handleCmsPage({
            ...res,
            page_id: cmsPageId
          })
          this.cmsStayDTO = res?.cmsStayDTO
          if (Array.isArray(res.page_data) && res.page_data.length) {
            this.showEmpty = false
            this.feedTabData =
              res.page_data.find(module => module.code === 'classify_tab') || {}
            this.renderFeedGood = this.feedTabData?.data?.length > 0

            this.strageTabData =
              res.page_data.find(
                module => module.code === 'mc_goods_strategy'
              ) || {}
            this.renderStrage = Object.keys(this.strageTabData).length > 0

            this.$refs.tangram.render(res)
            const hasGoods = !!res.page_data.find(
              module =>
                module.code === 'mc_goods_group' ||
                module.code === 'common_commodity' ||
                module.code === 'classify_tab' ||
                module.code === 'mc_goods_strategy' ||
                module.code === 'mc_billion_goods_group' ||
                module.code === 'mc_seckill' ||
                this.hotSpotWithGood(module)
            )
            // 是否展示购物车浮窗
            this.showCartFloatWindow = hasGoods && this.isMallAppMp

            if (!miniProgramEnv.isMiniProgram) {
              this.$nextTick(() => {
                const anchorDOMs =
                  document.getElementsByClassName('tangram-anchor')
                Array.prototype.forEach.call(
                  anchorDOMs,
                  item => (item.style.top = this.statusBarHeight + 44 + 'px')
                )
              })
            }
          } else {
            this.showEmpty = true
          }
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.$catch(error)
      }
    },

    goBack() {
      if (this.cmsStayDTO?.isOpen) {
        const { content, left, right, tickerInfo } = this.cmsStayDTO
        if (tickerInfo?.click?.spm) {
          tracerVuePlugin.request({
            spm: tickerInfo?.click?.spm,
            type: 8,
            page_id: 4035
          })
        }

        this.$dialog
          .confirm({
            confirmButtonText: right.content,
            cancelButtonText: left.content,
            message: content,
            confirmButtonColor: THEME_COLOR
          })
          .then(() => {
            const { tickerInfo } = right
            if (tickerInfo?.click?.spm) {
              this.$track(
                tickerInfo.click.spm,
                Object.assign({}, tickerInfo.click?.spmJson, tickerInfo?.data)
              )
            }
          })
          .catch(() => {
            const { tickerInfo } = left
            if (tickerInfo?.click?.spm) {
              this.$track(
                tickerInfo.click.spm,
                Object.assign({}, tickerInfo.click?.spmJson, tickerInfo?.data)
              )
            }
            this.$back()
          })
      } else {
        this.$back()
      }
    },

    // 判断热区组件是否携带有商品
    hotSpotWithGood(module) {
      if (module.code !== 'img_hotspot') return
      const hasGoods = !!module.data.find(hotSpot => {
        const hotSpotGood = hotSpot.hotData.find(
          data =>
            data?.smart_data?.smart_type === 98 ||
            data?.smart_data?.smart_type === 3
        )
        return hotSpotGood
      })
      return hasGoods
    },
    handleCmsPage(layout) {
      // setCmsHeader(layout)
      // 如果有headImgIsExists则表示使用渐变式导航头
      if (layout.headImgIsExists) {
        this.opacityNavBar = true
        window.addEventListener('scroll', e => {
          const boundingTop = this.$refs.tangram.$el.getBoundingClientRect().top
          if (boundingTop < -60) this.opacity = 1
          if (boundingTop >= 0) this.opacity = 0
          if (boundingTop > -60 && boundingTop < 0)
            this.opacity = Math.abs(boundingTop) / 60
        })
      }
      this.$nextTick(() => {
        // this.downLoadHeight = this.$refs.downloadWrap?.offsetHeight || 0
        this.downLoadHeight = 0
        this.pagePaddingTopValue = this.pagePaddingTop(this.downLoadHeight)
      })
      this.navBarTitle = layout.page_name
      document.title = layout.page_name
      this.handlePageTrack(layout)
      this.handleWxShare(layout)
    },
    handleWxShare(layout) {
      if (layout.is_share) {
        // eslint-disable-next-line no-undef
        setCmsWxShareInfo(layout)
        this.wxShareInfo.share_name = layout.share_name || ''
        this.wxShareInfo.share_img = layout.share_img || ''
        this.wxShareInfo.share_url = layout.share_url || ''
        this.wxShareInfo.share_desc = layout.share_desc || ''
        this.wxShareInfo.page_name = layout.page_name || ''
        if (miniProgramEnv.isMiniProgram) {
          mpsCombination.postMessage({
            data: {
              type: 'shareMessage',
              data: {
                title: layout.share_name || '',
                imageUrl: layout.share_img || ''
              }
            }
          })
          this.wxShareMpShow = true
          setTimeout(() => {
            this.wxShareMpShow = false
          }, 3000)
        }
        if (isMallApp()) {
          this.wxShareBtnAppShow = true
        }
      }
    },
    handlePageTrack(layout) {
      // 禁用自动巡航，需手动埋点
      tracerVuePlugin.page('#/cms/:cms_id', {
        cms_share: layout.is_share ? 1 : 0,
        cms_id: Number(layout.page_id) || 0,
        source_spm: resolveUrlParams().spm || '',
        spm: resolveUrlParams().spm || resolveUrlParams().tickReferId || ''
      })
    },
    wxShareBtnClick() {
      // eslint-disable-next-line no-undef
      onAppShareBtnClick(
        this.wxShareInfo,
        this.$trackMap.cmsPage.appWxSharePopBtnClick
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.wxshare-tip {
  position: absolute;
  top: 0.1rem;
  right: 0.3rem;
  z-index: 50;

  height: 0.64rem;
}
.wxshare-btn {
  position: fixed;
  bottom: 2.48rem;
  left: 0.6rem;
  z-index: 450;

  width: 1.08rem;
  height: 1.08rem;
}

.cms-nav-bar {
  position: fixed;
  top: 0;
  z-index: $z-navigation-bar;

  width: 100vw;
}

.download-wrap {
  display: flex;

  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 501;

  padding: 0.14rem 0.22rem;

  background-color: #ffffff;
  border-top: #f6f6f6 solid 1px;

  align-items: center;

  .logo {
    width: 0.68rem;
    height: 0.68rem;
  }

  .info {
    display: flex;

    width: 0;
    margin-left: 0.2rem;

    flex: 1;
    flex-direction: column;

    font-size: 0.24rem;

    .title {
      font-size: 0.28rem;
      font-weight: bold;
    }

    .desc {
      margin-top: 0.08rem;

      color: #666666;
    }
  }

  .btn {
    width: 1.12rem;
    height: 0.48rem;
    margin-left: 0.12rem;

    background-color: #15bb5c;
    border-radius: 0.4rem;

    font-size: 0.28rem;
    line-height: 0.5rem;
    text-align: center;
    color: #ffffff;
    &.open-btn {
      background-color: #f5f5f5;

      color: #15bb5c;
    }
  }
}

.expand-loading {
  display: flex;

  position: absolute;
  top: 0;
  right: 0;
  left: 0;

  height: 100vh;

  justify-content: center;
  align-items: center;

  .loading-content {
    display: flex;

    width: 60px;
    height: 60px;

    border-radius: 8px;

    justify-content: center;
    align-items: center;
    box-shadow: rgba(89, 89, 89, 0.1) 0px 0px 6px;

    .loading-img {
      width: 30px;
    }
  }
}
</style>
